import {Link} from "react-router-dom";
import Pagination from "components/helpers/pagination";
import Row from "./row";

function Heading() {
  return (
    <tr>
      <th>Active</th>
      <th>Rank</th>
      <th>Template</th>
      <th>Name</th>
      <th>Path</th>
      <th>Created At</th>
      <th>Actions</th>
    </tr>
  );
}

export default function List() {
  return (
    <div className="max-w-screen-lg mx-auto">
      <h1 className="text-center">Pages</h1>
      <div className="text-right mb-1">
        <Link className="btn btn-outline-black btn-sm" to="/admin/pages/new">New Page</Link>
      </div>
      <Pagination search={true} url="/api/admin/pages" Heading={Heading} Row={Row} />
    </div>
  );
}
